import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Input, RyeconMagnifyingGlass } from '@dbt-labs/sourdough';

import {
  isSubmitKey,
  MAXIMUM_QUERY_LENGTH,
  QUERY_TOO_LONG_MESSAGE,
} from '@/util/input';

interface SelectorInputParams {
  className?: string;
  autoFocus?: boolean;
  placeholder?: string;
}

export const AccountSearchInput = ({
  className,
  autoFocus,
  placeholder,
}: SelectorInputParams) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = searchParams.get('search') || '';
  const tabParam = searchParams.get('tab');
  const [searchInput, setSearchInput] = useState(searchParam);
  const isQueryTooLong = searchInput.length > MAXIMUM_QUERY_LENGTH;

  useEffect(() => {
    setSearchInput(searchParam);
  }, [searchParam]);

  return (
    <Input
      label="Search at the account level"
      labelIsHidden
      name=""
      isEdit
      startIcon={{ ryecon: RyeconMagnifyingGlass }}
      placeholder={placeholder}
      value={searchInput}
      error={isQueryTooLong ? QUERY_TOO_LONG_MESSAGE : undefined}
      className={`my-1 max-w-md flex-1 px-1 ${className} w-full`}
      onKeyDown={(event) => {
        if (isSubmitKey(event)) {
          if (isQueryTooLong) return;
          setSearchParams(() => ({
            ...(tabParam ? { tab: tabParam } : {}),
            search: searchInput,
          }));
        }
      }}
      onChange={(event) => {
        const input = event.target.value;
        setSearchInput(input);
      }}
      autoFocus={autoFocus}
    />
  );
};
